import React, { LegacyRef } from 'react';

import RadioButton from '@components/common/Form/RadioButton';

import { ITableSearch } from '@interfaces/components/table';

import styles from './FilterMenu.module.scss';

interface IFilterMenuProps {
	filterRef: LegacyRef<HTMLDivElement>;
	search: Array<ITableSearch>;
	selectedSearch: ITableSearch;
	handleChangeFilter: (value: string) => void;
}

const FilterMenu = ({
	filterRef,
	search,
	selectedSearch,
	handleChangeFilter,
}: IFilterMenuProps) => (
	<div
		ref={filterRef}
		className={styles.filterMenuContainer}
		data-testid='table-filter-menu'
	>
		<div className={styles.title}>Search by</div>
		{search.map((searchItem) =>
				(searchItem.name && searchItem.label)
				&& (
					<div
						key={searchItem.name}
						className={styles.radio}
					>
						<RadioButton
							key={searchItem.name}
							checked={selectedSearch.name === searchItem.name}
							id={searchItem.name}
							label={searchItem.label}
							name={searchItem.name}
							onChange={handleChangeFilter}
						/>
					</div>
				),
		)}
	</div>
);

export default FilterMenu;
